import { CheckCircle, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import JourneyLayout from '../../components/JourneyLayout';

function ThankYou() {
  const navigate = useNavigate();

  return (
    <JourneyLayout showJourneySidebar={false}>
      <div className="text-center space-y-6 py-8">
        <div className="flex flex-col items-center gap-4">
          <div className="relative w-16 h-16 rounded-full bg-theme/10 border-2 border-theme/20 flex items-center justify-center">
            <div className="absolute inset-0 rounded-full bg-theme/20 blur-xl" />
            <CheckCircle className="h-8 w-8 text-theme relative" />
          </div>
          <Heart className="h-5 w-5 text-theme2 fill-theme2" />
        </div>
        
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-gray-500 font-medium mb-2">Thank you</p>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            We've logged your response
          </h1>
          <p className="text-gray-600 mt-3 max-w-xl mx-auto text-base">
            Our team is reviewing your case. If we need anything else, we'll reach out to you on your registered number.
          </p>
        </div>
        
        <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl p-5 text-left space-y-2 max-w-md mx-auto">
          <p className="text-xs uppercase tracking-[0.2em] text-gray-500 font-medium">Next steps</p>
          <ul className="text-gray-700 text-sm space-y-1.5">
            <li>• Review in progress</li>
            <li>• We'll notify you via SMS & email</li>
            <li>• Check your dashboard for updates</li>
          </ul>
        </div>
        
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-theme to-theme2 text-white px-6 py-3 rounded-xl font-semibold text-base hover:opacity-90 transition-opacity shadow-md hover:shadow-lg"
        >
          Return Home
        </button>
      </div>
    </JourneyLayout>
  );
}

export default ThankYou;
